// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 76) return "assets/admin/js/76.js";
	if (chunkId === 415) return "assets/admin/js/415.js";
	if (chunkId === 224) return "assets/admin/js/224.js";
	if (chunkId === 90) return "assets/admin/js/90.js";
	if (chunkId === 846) return "assets/admin/js/846.js";
	if (chunkId === 724) return "assets/admin/js/724.js";
	if (chunkId === 778) return "assets/admin/js/778.js";
	if (chunkId === 404) return "assets/admin/js/404.js";
	if (chunkId === 884) return "assets/admin/js/884.js";
	if (chunkId === 746) return "assets/admin/js/746.js";
	if (chunkId === 810) return "assets/admin/js/810.js";
	if (chunkId === 329) return "assets/admin/js/329.js";
	if (chunkId === 443) return "assets/admin/js/443.js";
	if (chunkId === 16) return "assets/admin/js/16.js";
	if (chunkId === 106) return "assets/admin/js/106.js";
	if (chunkId === 936) return "assets/admin/js/936.js";
	if (chunkId === 28) return "assets/admin/js/28.js";
	if (chunkId === 896) return "assets/admin/js/896.js";
	if (chunkId === 365) return "assets/admin/js/365.js";
	if (chunkId === 234) return "assets/admin/js/234.js";
	if (chunkId === 480) return "assets/admin/js/480.js";
	if (chunkId === 993) return "assets/admin/js/993.js";
	if (chunkId === 455) return "assets/admin/js/455.js";
	if (chunkId === 687) return "assets/admin/js/687.js";
	if (chunkId === 983) return "assets/admin/js/983.js";
	// return url for filenames based on template
	return undefined;
};